import { FilterRoot, FilterSelect } from './Filter';

export const Filter = {
  Root: FilterRoot,
  Select: FilterSelect,
} as const;

export { FilterRoot, FilterSelect };
export type { FilterOption } from '@/shared/hooks/useFilterOptions';
